import Router from "./Router.js";
import DefaultController from "./Controllers/DefaultController.js";
import MainMenu from "./Controllers/MainMenu.js";
import ComputerMenu from "./Controllers/ComputerMenu.js";
import GameController from "./Controllers/GameController.js";
import AchievementsController from "./Controllers/AchievementsController.js";
import StoreController from "./Controllers/StoreController.js";
import FindServer from "./Controllers/FindServer.js";
import AvatarController from "./Controllers/AvatarController.js";
import ProfileController from "./Controllers/ProfileController.js";
import DeckController from "./Controllers/DeckController.js";
import GameModeController from "./Controllers/GameModeController.js";
import IAPMenuController from "./Controllers/IAPMenuController.js";
import CreateRoomController from "./Controllers/CreateRoomController.js";
import OnlineMenuController from "./Controllers/OnlineMenuController.js";
import LeaderBoardController from "./Controllers/LeaderBoardController.js";
import FindPlayerController from "./Controllers/FindPlayerController.js";
import StatsController from "./Controllers/StatsController.js";
import AboutController from "./Controllers/AboutController.js";
import CodeController from "./Controllers/CodeController.js";
import MoreGamesController from "./Controllers/MoreGamesController.js";
import LoginController from "./Controllers/LoginController.js";
import LoginEmailController from "./Controllers/LoginEmailController.js";
import RegisterController from "./Controllers/RegisterController.js";


import Items from "./Items.js";
import Test from "./Test.js";
import DataBinder from "./DataBinder.js"


import { RateApp } from '@cardsjd/rateapp';
import { IAP } from '@cardsjd/iap';
import { Share } from '@cardsjd/share';
import { Prompter } from '@cardsjd/prompter';
import { MarketPlace } from '@cardsjd/marketplace';
import { Storage } from '@cardsjd/storage';
import { EmailFeedback } from '@cardsjd/emailfeedback';
import { Device } from '@cardsjd/device';
import { Analytics } from '@cardsjd/analytics';
import { AccountJD } from '@cardsjd/accountjd';
import { Gamification } from '@cardsjd/gamification';
import { PushNotification } from '@cardsjd/pushnotification';
import { FBInstantGame } from '@cardsjd/fbinstantgame';
import { Achievements } from '@cardsjd/achievements';
import { Advertisement } from '@cardsjd/advertisement';
import { Localization } from '@cardsjd/localization';
import ConfigManager from '@cardsjd/configmanager';

//Game portals
import { Portal } from '@cardsjd/portal';

import Toast from "./Toast.js"
import Audio from "./Audio.js"

//configs
import Config from "./configs/AppConfig.js";
import AdvertisementConfig from "./configs/AdvertisementConfig.js";
import AchievementConfig from "./configs/AchievementConfig.js";
import ItemConfig from "./configs/ItemConfig.js";
import LocalizationConfig from './configs/LocalizationConfig.js';


export default class App {

	constructor() {
		//app properties
		this.userdata = {};
		this.device = new Device();
		this.platform = this.device.getPlatform();
		this.os = this.device.getOS();
		this.config = ConfigManager.resolve(Config, this.platform, this.os);

		//libraries
		this.localization = new Localization(LocalizationConfig);
		this.analytics = new Analytics(this.config);
		this.achievements = new Achievements(AchievementConfig);
		this.rateApp = new RateApp(this.config);
		this.emailFeedback = new EmailFeedback(this.config);
		this.gamification = new Gamification(3);
		this.items = new Items(ItemConfig);
		this.IAP = new IAP();
		this.IAP.onLoad = this.onIAPLoad.bind(this);
		this.IAP.onBuy = this.onIAPBuy.bind(this);
		this.test = new Test(this);
		this.dataBinder = new DataBinder();
		this.shareHelper = new Share(this.config);
		this.marketPlace = new MarketPlace(this.config);
		this.storage = new Storage();
		this.toast = new Toast();
		this.accountJD = new AccountJD();
		this.audio = new Audio();
		this.advertisement = new Advertisement(AdvertisementConfig);
		this.prompter = new Prompter(this.config);
		this.fBInstantGame = new FBInstantGame(this.config);
		this.pushNotification = new PushNotification();
		this.router = new Router(this, null, new DefaultController(this));
		this.portal = Portal.create(this.platform, this.config, AdvertisementConfig);

		//controllers and router
		this.controllers = {}
		this.controllers.MainMenu = new MainMenu(this);
		this.controllers.ComputerMenu = new ComputerMenu(this);
		this.controllers.Game = new GameController(this);
		this.controllers.Achievements = new AchievementsController(this);
		this.controllers.Store = new StoreController(this);
		this.controllers.FindServer = new FindServer(this);
		this.controllers.Avatar = new AvatarController(this);
		this.controllers.Profile = new ProfileController(this);
		this.controllers.Deck = new DeckController(this);
		this.controllers.GameMode = new GameModeController(this);
		this.controllers.IAPMenu = new IAPMenuController(this);
		this.controllers.CreateRoom = new CreateRoomController(this);
		this.controllers.OnlineMenu = new OnlineMenuController(this);
		this.controllers.LeaderBoard = new LeaderBoardController(this);
		this.controllers.FindPlayer = new FindPlayerController(this);
		this.controllers.Stats = new StatsController(this);
		this.controllers.About = new AboutController(this);
		this.controllers.Code = new CodeController(this);
		this.controllers.MoreGames = new MoreGamesController(this);
		this.controllers.Login = new LoginController(this);
		this.controllers.LoginEmail = new LoginEmailController(this);
		this.controllers.Register = new RegisterController(this);



		//get default resource
		this.resource = this.localization.getResource();

		//----init-----//
		this.router.controllers = this.controllers;
		this.router.onRoute = this.onRoute.bind(this);
		this.router.route("Loading");

		//wire up achievements
		this.achievements.onNewAchievement = this.onNewAchievement.bind(this);

		//wire up Advertisement
		this.advertisement.onAdRewarded = this.onAdRewarded.bind(this);
		this.advertisement.onAdLoaded = this.onAdLoaded.bind(this);
		this.advertisement.onAdOpened = this.onAdOpened.bind(this);

		this.device.onBackButton = this.onBackButton.bind(this);


		//load audio
		this.audio.load('CardClick', 'audio/click_lower_volumn.wav');
		this.audio.load('PointSound', 'audio/whoop.wav');
		this.audio.load('AchivementSound', 'audio/chime.wav');
		this.audio.load('WinSound', 'audio/win.wav');
		this.audio.load('swish', 'audio/swish.mp3');
		this.audio.load('swish2', 'audio/swish.wav');
		this.audio.load('bump', 'audio/bump.wav');
		this.audio.load('flipcard', 'audio/flipcard.wav');


		//notification wire up event handlers
		this.pushNotification.onTokenUpdated = this.onNotificationTokenUpdated.bind(this);
		this.pushNotification.onMessage = this.onNotificationMessage.bind(this);

		//share wire up events handlers
		if (this.config.showRateGame) {
			this.prompter.onPrompt = this.onPrompt.bind(this);
		}

		this.pluginInit();

		this.loadData();


	}
	async loadData() {
		let data = await this.storage.load(this.config.storageName);
		//if no data, load old key for upgrade
		if (!data) data = await this.storage.load("UserData");
		this.userdata = data || {};
		this.userdata.coins = this.userdata.coins ?? 0;

		//load portal data and init portal
		let platform = this.platform;
		console.log("Platform:", platform);

		//load portal data
		await this.portal.init();
		await this.portal.loadStart();
		const portalData = await this.portal.load();
		await this.portal.loadStop();

		//merge portal data into userdata
		if (portalData?.userdata) {
			//get userdata from crazygames storage - and get newest data
			const pUserdata = portalData.userdata;
			let overwrite = false;
			if (pUserdata && !this.userdata?.name) overwrite = true;
			if (pUserdata && pUserdata.game_open > (this.userdata?.game_open || 0)) overwrite = true;
			if (pUserdata && pUserdata.id > 0 && pUserdata.id !== (this.userdata?.id || 0)) overwrite = true;
			if (overwrite) {
				this.userdata = pUserdata; //needs to be this.userdata to keep reference
			}
		}
		if (portalData?.user) {
			const pUser = portalData.user;
			//update name and avatar from portal info
			if (pUser?.name && (!this.userdata?.name || this.userdata.name?.startsWith("Player"))) this.userdata.name = pUser.name;
			if (pUser?.avatar && !this.userdata?.avatar) this.userdata.avatar = pUser.avatar;
			if (pUser?.avatar && platform === "crazygames") this.userdata.avatar = pUser.avatar; //force avatar on crazygames (could the sync logic be in the portal?)
			if (pUser?.facebookId) this.userdata.facebookId = pUser.facebookId;
			if (pUser?.crazyGamesId) this.userdata.crazyGamesId = pUser.crazyGamesId;
			if (pUser?.avatar_discord) this.userdata.avatar_discord = pUser.avatar_discord;
			if (pUser?.guildId) this.userdata.roomId = pUser.guildId;
			if (pUser?.roomId) this.userdata.roomId = pUser.roomId;
			if (pUser?.discordId) this.userdata.discordId = pUser.discordId;

			//update avatar to server if needed
			this.updateAvatarToServer(platform);
		}
		//clean up old facebook avatar if still using
		if (this.userdata.avatar && (this.userdata.avatar.includes("facebook") || this.userdata.avatar.includes("fbsbx") || this.userdata.avatar.includes("fbcdn") || this.userdata.avatar.includes("graph.facebook"))) {
			delete this.userdata.avatar;
		}

		//if no name, set default name
		if (!this.userdata.name) this.userdata.name = "Player" + Math.floor(Math.random() * 10000);

		//if no avatar, get random avatar
		if (!this.userdata.avatar) this.userdata.avatar = this.items.getRandomAvatar();

		//else
		this.dataLoaded();
	}
	async dataLoaded() {
		const userdata = this.userdata;

		//// Skip login for new users for now - login will be force when entering online pages.
		// let isLoggedIn = userdata?.id;
		// if (!isLoggedIn && !this.config.autoLogin) {
		// 	this.navigate("Login"); // will call dataLoaded() when done
		// 	return;
		// }

		//tracking
		let mode = null;
		if (userdata.removeAds) mode = "RemoveAds";
		if (userdata.fullVersion) mode = "FullVersion";
		this.analytics.setOptions({ mode: mode, userId: userdata.id });
		this.analytics.trackStart();

		//set localization resource based on user settings
		if (this.userdata.language) {
			this.resource = this.localization.getResource(this.userdata.language);
		}

		//ui settings
		this.audio.isMuted = userdata.isMuted;

		//IAP
		let iapProductIds = this.items.allItems.filter(i => i.type === "IAP").map(i => i.id);
		this.IAP.init(iapProductIds).catch(e => console.log("IAP.init() failed", e));

		//notifications
		this.pushNotification.init();
		this.pushNotification.RegisterNotification();

		//ask to rate / share
		this.prompter.delayedPrompt();

		this.requestTrackingAuthorizationWithExplainer();

		//log game opened
		userdata.game_open = (userdata.game_open || 0) + 1;

		//save os in profile
		userdata.os = this.device.getOS();
		userdata.platform = this.device.getPlatform();
		userdata.browser = this.device.getBrowser();
		userdata.version = this.config.version;

		this.createShortCutTry();

		if (this.page != "Game") {

			await this.showAppOpenAd();

			this.navigate("MainMenu");
		}
		// this.advertisement.showAppOpenAd().finally(() => {
		//     console.log("showAppOpenAd - finished");
		// });
	}
	navagate(path) {
		this.router.route(path);
	}
	save(forceSave) {
		const userdata = this.userdata;
		if (userdata) this.audio.isMuted = userdata.isMuted;

		const hasData = userdata && (userdata.id || userdata.email || userdata.facebookId);
		if (!hasData && !forceSave) { console.warn("save(): No user id or email or facebookId"); }

		let storage = this.storage.save(this.config.storageName || "UserData", userdata).catch(function () { });
		let saveServer = this.saveServer(userdata, forceSave).catch(function () { });
		let fBSaveData = this.fBInstantGame.saveData(userdata, forceSave).catch(function () { });
		return Promise.resolve()
			.then(storage)
			.then(saveServer)
			.then(fBSaveData)
			.catch(function (ex) {
				console.log(ex);
			});
	}
	async saveServer(userdata, forceSave) {

		if (!userdata) throw ("No userdata");
		if (!userdata.id) throw ("No user Id");

		if (!forceSave) {
			//throttle: once per ... 
			let lastSync = userdata.lastSync || 0;
			let now = Date.now();
			let timeElapsed = now - lastSync;
			let minTimeElapsed = 1000 * 60 * 30; //60 minutes
			if (timeElapsed < minTimeElapsed) {
				let message = "No data sent: throttled " + timeElapsed + "/" + minTimeElapsed;
				return message;
			}
		}

		userdata.lastSync = Date.now();

		//save to server database
		try {
			await this.accountJD.UpdateUser(userdata);
			console.log("Saved user data to DB");
		} catch (ex) {
			console.log(ex);
		}
		//save to server file
		try {
			await this.accountJD.SaveUserData(userdata.id, userdata)
			console.log("Saved user data to Backup");
		} catch (ex) {
			console.log(ex);
		}
	}
	login(username, password) {
		console.log("Login: start");
		return this.accountJD.Login(username, password)
			.then(function (data) {
				if (!data || !data.id) return;
				if (data.id) this.userdata.id = data.id;
				if (data.name) this.userdata.name = data.name;
				if (data.email) this.userdata.email = data.email;
				if (data.facebookId) this.userdata.facebookId = data.facebookId;
				if (data.avatar) this.userdata.avatar = data.avatar;
				if (data.emailSubscribe) this.userdata.emailSubscribe = data.emailSubscribe;
				//clear password
				this.userdata.password = null;
				console.log("Login: finish");
				//todo: login or pass toke to get data from server
				return this.loadUserDataServer(data.id)
					.catch(function (reason) {
						//if no server data, load local data
						return {
							id: data.id,
							name: data.name,
							deviceId: data.deviceId,
							email: data.email,
							facebookId: data.facebookId
						};
					}.bind(this));


			}.bind(this));
	}
	async loadUserDataServer(id) {
		if (!id) id = this.userdata.id;
		//load data from server
		console.log("loadUserDataServer: start")
		const data = await this.accountJD.GetUserData(id);
		if (data) {
			console.log("loadUserDataServer: finish")
			//validate it is the right data
			if (data.id == id) {
				//set defaults
				if (!data.name) data.name = "Player" + Math.floor(Math.random() * 10000);
				this.userdata = data;
				this.populate();
			}
		}
		return data;
	}
	populate() {
		this.router.route();
	}
	pluginInit() {
		document.addEventListener("deviceready", function () {
			console.log("--deviceready--------");
		}, false);
	}
	onRoute(path, pageId) {
		if (pageId == "MainMenu") {
			this.showAd();
			this.save();
		}
		if (pageId == "ComputerMenu") {
			this.showAd();
			this.save();
		}
		if (pageId == "OnlineMenu") {
			this.requestNotificationAuthorizationWithExplainer();
			this.showAd();
			this.save();
		}


		//TrackPage(pageId);
	}
	get page() {
		return this.router.lastPage;
	}
	navigate(path) {
		this.router.navigate(path);
	}
	onBackButton() {
		//check for any popups
		const dialogBoxs = document.querySelectorAll(".dialogBox");
		for (let i = 0; i < dialogBoxs.length; i++) {
			let dialogBox = dialogBoxs[i];
			if (dialogBox && dialogBox.style && dialogBox.style.display != "none" && dialogBox.style.display != "") {
				dialogBox.style.display = "none";
				return;
			}
		}

		//exit app
		if (this.page === "MainMenu") {
			this.device.exitApp();
		} else {
			this.navigate("/");
			//navigator.app.backHistory();
		}

		// if (this.test && this.test.testAutomator) {
		//   this.test.testAutomator.stop();
		// }
	}
	async requestNotificationAuthorizationWithExplainer(forceShow) {
		let showExplainer = false;

		if (this.pushNotification && this.pushNotification.CanAskPermissions) {
			const canAskPermissions = await this.pushNotification.CanAskPermissions();
			showExplainer = canAskPermissions;
		}

		if (showExplainer || forceShow) {
			let model = {
				title: "Friend Invites",
				message: "Push notfications are required to receive friend invites. Tap “Allow” on the next screen to give permission.",
				clickAction: function () { this.pushNotification.RequestPermissions(); }.bind(this),
				resource: this.resource
			}
			this.dataBinder.createAndShow("okTemplate", model);
		}
	}
	async requestTrackingAuthorizationWithExplainer(forceShow) {

		//todo: move consent to advertisement library

		let showExplainer = false;
		if (typeof cordova !== 'undefined' && typeof consent !== 'undefined' && cordova.platformId === 'ios') {
			const status = await consent.trackingAuthorizationStatus();
			//trackingAuthorizationStatus:  0 = notDetermined  1 = restricted 2 = denied 3 = authorized 
			if (status === 0) {
				showExplainer = true;//show explainer
			}
		}
		if (showExplainer || forceShow) {
			let model = {
				title: "Our app wants to stay free for you",
				message: "Ads help support our business. Tap “Allow” on the next screen to give permission to show ads that are more relevant to you.",
				clickAction: function () { this.requestTrackingAuthorization() }.bind(this),
				resource: this.resource
			}
			this.dataBinder.createAndShow("okTemplate", model);
		}
	}
	async requestTrackingAuthorization() {
		if (typeof cordova !== 'undefined' && typeof consent !== 'undefined' && cordova.platformId === 'ios') {
			const statusNew = await consent.requestTrackingAuthorization();
		}
	}
	async showAd(force) {


		if (force) {
			await this.advertisement.setUp();
			await this.advertisement.showInterstitialAd();
			return;
		}
		//fullversion or remove ads
		if (this.userdata.fullVersion || this.userdata.removeAds) return;
		//only show if 3th+ time opening app
		if ((this.userdata.game_open || 0) < 3) return;

		await this.advertisement.setUp();
		await this.advertisement.tryShowInterstitialAd();
	}
	async showRewardedAd() {
		await this.advertisement.setUp();
		await this.advertisement.showRewardedAd();
	}
	async showAppOpenAd(force) {

		const userdata = this.userdata;
		if (!force) {
			//fullversion or remove ads
			if (userdata.fullVersion || userdata.removeAds) {
				console.log("showAppOpenAd - skipped: fullVersion or removeAds");
				return;
			}
			//only show if 3th+ time opening app
			if ((userdata.game_open || 0) < 3) {
				console.log(`showAppOpenAd - skipped: ${userdata.game_open} < 3`);
				return;
			}
			//show only 1 in 3 times
			const random = Math.random();
			if (random > 0.30) {
				console.log(`showAppOpenAd - skipped: ${random}  > 0.30`);
				return;
			}
		}

		//show ad
		await this.advertisement.setUp();
		await this.advertisement.showAppOpenAdWithMaxDelay(4000);
	}

	onAdLoaded(data) {
		console.log(`onAdLoaded`, data);
		this.analytics.track("AdLoaded", data?.adType, data?.adProvider);
	}
	onAdOpened(data) {
		console.log(`onAdOpened`, data);
		this.analytics.track("AdOpened", data?.adType, data?.adProvider);
	}
	onAdRewarded(rewardAmount, rewardType) {
		const userdata = this.userdata;
		const achievements = this.achievements;

		userdata.rewardAdCount = (userdata.rewardAdCount || 0) + 1;
		userdata.coins = (userdata.coins || 0) + 150;
		this.showToast("You have received +150 coins");
		//check for reward in achievements
		achievements.checkForAchievementAndReward(userdata);


		//repopulate current page
		this.router.route();
		this.save(userdata, true);
	}
	playSound(id) {
		let isMuted = this.userdata.isMuted;
		if (!isMuted) {
			this.audio.play(id);
		}
	}
	onNotificationTokenUpdated(token, deviceId) {
		if (!this.userdata) return false; //no reason to get token if no Id.
		if (!this.userdata.id) return false; //no reason to get token if no Id.

		let userId = this.userdata.id;
		this.gamification.RegisterNotificationFCM(userId, token, deviceId);
	}
	onNotificationMessage(data) {
		var action = data.action;
		var room = data.room;
		var server = data.server;
		var message = data.message;
		var avatar = data.avatar;
		var userId = data.userId;
		var name = data.name;
		var coins = data.coins;
		var item = data.item;
		var url = data.url
		//try to pull room from message text [room:2134]
		if (message) {
			let matches = message.match(/\[room:(.*?)\]/);
			if (matches) {
				var submatch = matches[1];
				room = submatch;
				action = "invite";
			}
		}
		if (action === "invite") {
			let invite = {
				name: name,
				userId: userId,
				avatar: avatar,
				room: room,
				message: message,
				server: server
			};
			this.showInvitePopup(invite);
		}
	}
	onPrompt(message, os) {
		if (os == "FBMessenger") {
			this.showSharePopup(message);
		}
		else {
			//ask if like game then ask to rate
			this.showEnjoyGame(message);
		}
		this.rateApp.rateNative();
	}
	showEnjoyGame(message) {
		if (!message) message = "Are you enjoying the Game?";
		let model = {
			message: message,
			yesCommand: "app.showAskRate();",
			noCommand: "",
			yes: 'Yes',
			no: 'No'
		}
		this.showDialog(model);
	}
	showAskRate(message) {
		if (!message) message = "Rate the app?"
		let model = {
			message: message,
			yesCommand: "app.rate();",
			noCommand: "",
			yes: 'Yes',
			no: 'No'
		}
		this.showDialog(model);
	}
	showSharePopup(message) {
		if (!message) message = "Would you like to share?"
		let model = {
			message: message,
			yesCommand: "app.share();",
			noCommand: "",
			yes: 'Yes',
			no: 'No'
		}
		this.showDialog(model);
	}
	showInvitePopup(invite) {
		//check if friend
		let isFriend = false;
		if (this.userdata.friends) {
			if (invite) {
				let exist = this.userdata.friends.some(function (user) {
					return user.id == invite.userId;
				});
				isFriend = exist;
			}
		}
		//check if blocked
		if (!isFriend && this.userdata.blockedPlayers) {
			if (invite) {
				let exist = this.userdata.blockedPlayers.indexOf(invite.userId) !== -1;
				if (exist) {
					console.log("Blocked player invite from " + invite.userId, invite);
					return;
				}
			}
		}
		let message = invite.message;
		if (!invite.message && invite.name) invite.message = invite.name + " has invited you to play";
		if (!invite.message) invite.message = "A Player has invited you to play";
		let model = {
			message: message,
			userId: invite.userId,
			name: invite.name,
			avatar: invite.avatar,
			room: invite.room,
			isFriend: isFriend,
			server: invite.server || ""
		};

		//copy template and populate
		let element = this.dataBinder.create("inviteTemplate", model);
		this.showToast(element, 20);
	}
	showBlockPopup(userId, name) {
		let message = `Are you sure you want to block ${name} the player forever?`;
		let model = {
			message: message,
			yesCommand: `app.blockPlayer(${userId},'${name}');`,
			noCommand: "",
			yes: 'Yes',
			no: 'No'
		}
		this.showDialog(model);
	}
	blockPlayer(id, name) {
		// //block player
		// if (!id) return;
		// if (!this.userdata.blockedPlayers) this.userdata.blockedPlayers = [];
		// if (this.userdata.blockedPlayers.indexOf(id) === -1)
		//     this.userdata.blockedPlayers.push(id);

		// this.showToast(name + " Blocked");

		// ////update socket server data
		// //if (this.gameServer) this.gameServer.login(this.userdata);
		// if (this.gameServer) this.gameServer.block(id);
	}
	rate() {
		this.rateApp.rate();
		this.achievements.awardAchivement(this.userdata, "Rate Game");
		//TrackEvent("Rate");
	}
	share() {
		this.shareHelper.share();
		this.achievements.awardAchivement(this.userdata, "Share Game");
		//TrackEvent("Share");
	}
	feedback() {
		this.emailFeedback.send(this.userdata);
		this.achievements.awardAchivement(this.userdata, "Send Feedback");
		//TrackEvent("Feedback");
	}
	equipItem(name) {
		let item = this.items.getItem(name);
		if (!item) return;
		//equip it
		if (item.type === "Avatar")
			this.userdata.avatar = item.url;
		if (item.type === "Deck")
			this.userdata.deck = name;
		if (item.type === "Board")
			this.userdata.board = name;
		if (item.type === "Background")
			this.userdata.background = name;

	}
	buyItem(name) {
		const userdata = this.userdata;
		const items = this.items;
		let coins = userdata.coins || 0;
		let ownedItems = userdata.items || [];
		let fullVersion = userdata.fullVersion;
		//check if already have it (item)
		let owned = ownedItems.includes(name);
		if (owned) {
			this.equipItem(name);
			return true;
		} else {
			let item = items.getItem(name);
			if (!item) return;
			let cost = fullVersion ? 0 : item.cost;
			//buy it
			if (item && cost <= coins) {
				//subtract coins
				userdata.coins = coins - cost;

				//give item
				if (!userdata.items) userdata.items = [];
				userdata.items.push(item.name);

				//equip it
				this.equipItem(name);

				//notification
				this.showNewItemPopup(name);
				return true;
			}
			//No enough coins
			if (item && cost > coins) {
				this.showToast("Not enough coins");
				//this.IAPMenu();
			}
		}
	}
	showToast(element, duration) {
		//play sound
		this.playSound("PointSound");

		this.toast.show(element, duration);
	}
	showDialog(model, template) {
		if (!template) template = "yesNoTemplate";
		if (!model) model = {
			message: "",
			yesCommand: "", //`app.blockPlayer(${userId},'${name}');`
			noCommand: "",
			yes: 'Yes',
			no: 'No'
		}
		this.dataBinder.createAndShow(template, model);
	}

	showNewItemPopup(itemName) {
		let item = this.items.getItem(itemName);
		if (!item) return;
		let modelItem = {
			title: "New Item!",
			description: item.title,
			image: item.icon
		};
		let itemElement = this.dataBinder.create("itemNotification", modelItem);
		this.toast.show(itemElement);
		this.playSound("AchivementSound");
	}
	showAchievementPopup(achievements) {
		//play sound
		this.playSound("AchivementSound");
		for (var i = 0; i < achievements.length; i++) {
			let achievement = achievements[i];
			let model = {
				title: achievement.title,
				description: achievement.description,
				image: achievement.image,
				points: achievement.points
			};
			let achievementElement = this.dataBinder.create("achievementNotification", model);
			this.toast.show(achievementElement, 8);
			//check for item
			if (achievement.item) {
				this.showNewItemPopup(achievement.item)
			}

		}
		return;
	}

	onNewAchievement(achievements) {
		this.showAchievementPopup(achievements);
	}
	onIAPLoad() {

	}
	onIAPBuy(productId) {
		const userdata = this.userdata;
		if (!productId) return;

		//log IAP
		if (!userdata.IAPs) userdata.IAPs = [];
		//duplicate IAPs are being logged for durable IAPs - clear all duplicates for that durable IAPs
		//todo: 3/27/2024 change code to only add durable IAPs once if it is not already in the list rather than removing duplicates
		let durableIAPs = ["fullversion", "com.jdsoftwarellc.speed.removeads"];
		let isProductDurable = durableIAPs.includes(productId);
		if (isProductDurable) {
			this.userdata.IAPs = this.userdata.IAPs.filter(i => i !== productId);
		}

		//reaward item
		if (productId === "fullversion") {
			if (userdata.fullVersion !== true) {
				this.showToast("Full version granted");
			}
			userdata.fullVersion = true;
			const hasProductDurableFullVersion = userdata.IAPs.includes(productId);
			if (!hasProductDurableFullVersion) {
				userdata.IAPs.push(productId);
			}
		}
		if (productId === "com.jdsoftwarellc.speed.removeads") {
			if (userdata.removeAds !== true) {
				this.showToast("Ads have been removed");
			}
			userdata.removeAds = true;
			const hasProductDurableRemoveAds = userdata.IAPs.includes(productId);
			if (!hasProductDurableRemoveAds) {
				userdata.IAPs.push(productId);
			}
		}
		if (productId === "com.jdsoftwarellc.speed.coins2000") {
			userdata.coins = (userdata.coins || 0) + 2000;
			this.showToast("Your have received 2,000 coins");
			userdata.IAPs.push(productId);
		}
		if (productId === "com.jdsoftwarellc.speed.coins5000") {
			userdata.coins = (userdata.coins || 0) + 5000;
			this.showToast("Your have received 5,000 coins");
			userdata.IAPs.push(productId);
		}
		if (productId === "com.jdsoftwarellc.speed.coins10000") {
			userdata.coins = (userdata.coins || 0) + 10000;
			this.showToast("Your have received 10,000 coins");
			userdata.IAPs.push(productId);
		}
		if (productId === "com.jdsoftwarellc.speed.coins20000") {
			ts.userdata.coins = (userdata.coins || 0) + 20000;
			this.showToast("Your have received 20,000 coins");
			userdata.removeAds = true;
			this.showToast("Ads have been removed");
			userdata.IAPs.push(productId);
		}



		//repopulate current page
		this.router.route();
		this.save(userdata, true);
	}
	IAPRestore() {
		return this.IAP.restore();
	}
	IAPBuy(id) {
		this.IAP.buy(id);
	}

	joinCustomRoom(room, serverUrl) {
		if (!serverUrl)
			this.navigate("Game/Online/" + room);
		if (serverUrl)
			this.navigate("Game/Online/" + room + "/" + encodeURIComponent(serverUrl));
	}
	pushNotification() {
		this.pushNotification.RegisterNotification();
	}
	createShortCutTry() {
		if (this.userdata && this.userdata.game_open) {
			if (this.userdata.game_open === 5
				|| this.userdata.game_open === 30
				|| this.userdata.game_open === 100) {
				this.portal.createShortCut();
			}
		}
	}
	async autoLogin() {
		let userdata = this.userdata;
		if (!userdata) return;
		console.log("accountJD.Register - autoLogin()");
		const data = await this.accountJD.Register(this.userdata);

		if (data.id) {
			this.userdata.id = data.id;
			return true;
		}
		return false;
	}
	updateAvatarToServer(suffix) {
		if (!this.userdata.id) return;
		if (!this.userdata.avatar) return;
		if (this.userdata.avatar.indexOf('instantgames') !== -1) //push avatars that are from paltforms to save to JD avatar server
			//save avatar image on server and set
			this.accountJD.UploadAvatarUrl(this.userdata.id + (suffix || ""), this.userdata.avatar).then((url) => {
				if (url) {
					this.userdata.avatar = url;
				}
			});
	}
}
